<div class="grid-x">
  <div class="cell large-3 small-2 medium-1 align-center">
    <fa-icon [icon]="auditLog | auditLogTitleHelper: 'icon'" style="margin-right: 16px;"></fa-icon>
    <label style="font-style: italic">{{auditLog.timestamp | commonDate}}</label>
  </div>
  <div class="cell large-2 small-12 medium-12">
    <p style="font-weight: bold"> {{auditLog.user || 'System'}}</p>
  </div>
  <div class="cell large-7 small-12 medium-12" *ngIf="!subject.length">
    <label>{{auditLog.subject}}</label>
  </div>
  <div class="cell large-7 small-12 medium-12" *ngIf="subject.length">
    <label>{{subject[0]}}
    <a class="a-link-no-underline" style="margin-left: 4px" (click)="navigate()" target="_blank">{{urlValue}}</a>
    {{subject[1]}}</label>
  </div>
</div>

<div class="grid-x" *ngIf="descriptionVisible && auditLog.content">
  <div class="cell large-3 small-0 medium-0"></div>
  <div class="cell large-9 small-0 medium-0">
    <pre *ngIf="auditLog.contentType === 'text/plain'" style="white-space: pre-line;" lang="text">{{auditLog.content}}</pre>
    <span *ngIf="!auditLog.contentType || auditLog.contentType === 'text/html'" [innerHTML]="auditLog.content"></span>
    <pre *ngIf="auditLog.contentType === 'application/xml'" lang="xml">{{auditLog.content}}</pre>
    <pre *ngIf="auditLog.contentType === 'application/json'" lang="json">{{auditLog.content}}</pre>
  </div>
</div>
